import { createApiClient } from '@readlater/api-client';
import { getFirebaseAuth } from './firebase';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';
const MOCK_MODE = import.meta.env.VITE_MOCK_API === 'true';

export const api = createApiClient({
  baseUrl: `${API_URL}/v1`,
  getToken: async () => {
    const auth = getFirebaseAuth();
    const token = await auth?.currentUser?.getIdToken();
    return token ?? null;
  },
  mockEnabled: MOCK_MODE,
});

// Re-export for consumers that import ApiError
export { ApiError } from '@readlater/api-client';
